import showNotification from '@shoflo/studio-redux/actions/notification/showNotification';

function mixerTaskFailed({ dispatch }, { mixerTaskType }) {
  const message = `We found an issue with a ${mixerTaskType}. Try restarting it for the best experience.`;
  dispatch(
    showNotification(message, {
      timeout: 5000,
      type: 'alert'
    })
  );
}

export default mixerTaskFailed;
